import * as React from 'react';
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";
import {startLoading, finishLoading} from "./../../store/reducers/Loading";
import { handleError } from './handleError';

export function useBackgroundPromiseEffect<T>(
  call: () => Promise<AxiosResponse<T>>,
  afterCall: (x: T) => void,
  dependencies: React.DependencyList,
  disableAnimation?: boolean
) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  React.useEffect(() => {
    let response: AxiosResponse<T> | undefined;

    const sendRequest = async () => {
      try {
        if (!disableAnimation) dispatch(startLoading);
        setIsLoading(true);
        response = await call();
      } catch (err) {
        handleError(err, dispatch)
      } finally {
        if (!disableAnimation) dispatch(finishLoading);
        setIsLoading(false);
      }
      if (response !== undefined) {
        if (response.status === 200) {
          afterCall(response.data);
        }
      }
    };

    sendRequest();
    // eslint-disable-next-line
  }, dependencies);

  return isLoading;
}
